export default __webpack_public_path__ + "static/media/card4.30b0d902.png";